
export function SubsidyTable() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            補助金の活用でさらにお得に導入できます！
          </h2>
          <p className="text-gray-600 text-lg">
            お住まいの地域で補助金額が異なりますので、詳しくはご相談ください
          </p>
        </div>

        {/* 重要注釈 */}
        <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg">
          <div className="flex items-start space-x-3">
            <i className="ri-alarm-warning-line text-2xl text-amber-600 flex-shrink-0 mt-1"></i>
            <div>
              <h4 className="font-bold text-amber-900 mb-2 text-lg">
                補助金申請の重要なお知らせ
              </h4>
              <p className="text-amber-800 leading-relaxed">
                <strong>補助金は着工前の申請が必要です。</strong>予算には限りがあるため、お早めのご相談をおすすめします。当社が申請手続きを全面サポートいたしますので、ご安心ください。
              </p>
            </div>
          </div>
        </div>

        {/* 補助金シミュレーションCTA */}
        <div className="text-center mt-10">
          <button
            onClick={() => {
              const contactSection = document.getElementById('contact-section');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calculator-line mr-2"></i>
            あなたの補助金額を無料診断
          </button>
        </div>
      </div>
    </section>
  );
}
